/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

let exports = {};

// 获取公司角色列表
exports.getRetailerComRoleList = function (params, callback) {// 获取公司角色
    api.post('/retailer/authx/com/role/list/get')
    .data(params)
    .done(callback)
    .go();
};
exports.getRetailerComRoleListByBizUnitId = function (params, callback) {// 获取公司角色
    api.post('/retailer/authx/com/role/list/get/by/bizUnitId')
    .data(params)
    .done(callback)
    .go();
};
// 获取公司角色
exports.getRetailerComRole = function (params, callback) {// 获取公司角色
    api.get('/retailer/authx/com/role/get')
    .params(params)
    .done(callback)
    .go();
};

// 保存公司角色
exports.saveRetailerComRole = function (params, callback) {// 保存公司角色
    api.post('/retailer/authx/com/role/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 更新公司角色
exports.updateRetailerComRole = function (params, callback) {// 更新角色
    api.post('/retailer/authx/com/role/update/do')
    .data(params)
    .done(callback)
    .go();
};
// 排序
exports.moveRetailerComRoleSeq = function (params, callback) {// 上下移条目
    api.post('/retailer/authx/com/role/seq/move/do')
    .data(params)
    .done(callback)
    .go();
};
// 启、禁用-公司岗位
exports.updateRetailerComRoleForDisabled = function (data, callback) {
    api.post('/retailer/authx/com/role/update/disabled/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除角色
exports.deleteRetailerComRole = function (data, callback) {
    api.post('/retailer/authx/com/role/delete/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getRetailerComRoleQrCodeUrl = function (data, callback) {
    api.post('/retailer/authx/com/role/qrCode/url/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getRetailerComRoleRescRescIdsByRoleId = function (params, callback) {// 获取系统资源列表（带拥有标记）
    api.post('/retailer/authx/com/role/resc/rescIds/get/by/roleId')
    .data(params)
    .done(callback)
    .go();
};
// 根据uk获取角色资源
exports.getRetailerComRoleRescByRoleIdAndRescId = function (params, callback) {// 获取系统资源列表（带拥有标记）
    api.post('/retailer/authx/com/role/resc/get/by/roleId/and/rescId')
    .data(params)
    .done(callback)
    .go();
};
// 修改角色资源
exports.updateRetailerComRoleRescs = function (params, callback) {// 保存公司角色资源关系
    api.post('/retailer/authx/com/role/resc/update/do')
    .data(params)
    .done(callback)
    .go();
};
// 保存角色资源
exports.saveRetailerComRoleRescs = function (params, callback) {// 批量保存公司角色资源
    api.post('/retailer/authx/com/role/rescs/save/do')
    .data(params)
    .done(callback)
    .go();
};
// 删除角色资源
exports.deleteRetailerComRoleRescByComIdAndRoleIdAndTypeAndScope = function (params, callback) {// 批量保存公司角色资源
    api.post('/retailer/authx/com/role/resc/delete/do/by/filter')
    .data(params)
    .done(callback)
    .go();
};
// 获取人员角色列表
exports.getRetailerStaffRoleList = function (params, callback) {// 获取公司人员角色
    api.post('/retailer/authx/staff/role/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 为公司角色关联人员
exports.doSrelevStaffsForComRole = function (params, callback) {// 为公司角色关联人员
    api.post('/retailer/authx/staff/role/srelev/do')
    .data(params)
    .done(callback)
    .go();
};

// 替换人员角色
exports.replaceRetailerStaffRole = function (params, callback) {// 替换公司人员角色
    api.post('/retailer/authx/staff/role/replace/do')
    .data(params)
    .done(callback)
    .go();
};

// =============================================== 业务设置 ==================================================
// =============
// 根据岗位id获取岗位_商品分类catIds
exports.getRetailerComRoleGoodsCatCatIdsByRoleId = function (params, callback) {
    api.post('/retailer/authx/com/role/goods/cat/catIds/get')
    .data(params)
    .done(callback)
    .go();
};
// 根据唯一件获取岗位_商品分类列表
exports.getRetailerComRoleGoodsCatByUk = function (params, callback) {
    api.post('/retailer/authx/com/role/goods/cat/get/by/uk')
    .data(params)
    .done(callback)
    .go();
};
// 获取岗位_商品分类列表
exports.getRetailerComRoleGoodsCatList = function (params, callback) {
    api.post('/retailer/authx/com/role/goods/cat/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 保存岗位_商品分类列表
exports.saveRetailerComRoleGoodsCat = function (params, callback) {
    api.post('/retailer/authx/com/role/goods/cats/save/do')
    .data(params)
    .done(callback)
    .go();
};

// =============

// 根据岗位id获取岗位_服务分类catIds
exports.getRetailerComRoleServcCatCatIdsByRoleId = function (params, callback) {
    api.post('/retailer/authx/com/role/servc/cat/catIds/get')
    .data(params)
    .done(callback)
    .go();
};
// 根据唯一件获取岗位_服务分类列表
exports.getRetailerComRoleServcCatByUk = function (params, callback) {
    api.post('/retailer/authx/com/role/servc/cat/get/by/uk')
    .data(params)
    .done(callback)
    .go();
};
// 获取岗位_服务分类列表
exports.getRetailerComRoleServcCatList = function (params, callback) {
    api.post('/retailer/authx/com/role/servc/cat/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 保存岗位_服务分类列表
exports.saveRetailerComRoleServcCat = function (params, callback) {
    api.post('/retailer/authx/com/role/servc/cats/save/do')
    .data(params)
    .done(callback)
    .go();
};

// =============
// 根据岗位id获取岗位_机构comIds
exports.getRetailerComRoleOrgComIds = function (params, callback) {
    api.post('/retailer/authx/com/role/org/comIds/get')
    .data(params)
    .done(callback)
    .go();
};
// 根据唯一件获取岗位_机构列表
exports.getRetailerComRoleOrgByUk = function (params, callback) {
    api.post('/retailer/authx/com/role/org/get/by/uk')
    .data(params)
    .done(callback)
    .go();
};
// 获取岗位_机构列表
exports.getRetailerComRoleOrgList = function (params, callback) {
    api.post('/retailer/authx/com/role/org/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 保存岗位_机构列表
exports.saveRetailerComRoleOrg = function (params, callback) {
    api.post('/retailer/authx/com/role/orgs/save/do')
    .data(params)
    .done(callback)
    .go();
};

// =============
// 获取岗位_地区列表
exports.getRetailerComRoleRegionList = function (params, callback) {
    api.post('/retailer/authx/com/role/region/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 保存岗位_地区列表
exports.saveRetailerComRoleRegion = function (params, callback) {
    api.post('/retailer/authx/com/role/regions/save/do')
    .data(params)
    .done(callback)
    .go();
};

// 更新岗位_移动端(固定)角色
exports.updateRetailerComRoleMobAppRole = function (data, callback) {
    api.post('/retailer/authx/com/role/mob/app/role/update/do')
    .data(data)
    .done(callback)
    .go();
};

// 清除岗位_手机APP(固定)角色
exports.updateRetailerComRoleMobAppRoleForClear = function (data, callback) {
    api.post('/retailer/authx/com/role/mob/app/role/update/for/clear/do')
    .data(data)
    .done(callback)
    .go();
};

//【移动端（固定）角色】关联资源-获取角色已关联的资源操作(回显)
exports.getMobAppRoleRescListForOwn = function (data, callback) {
    api.post('/retailer/authx/mob/role/resc/list/for/own')
    .data(data)
    .done(callback)
    .go()
};

// 【移动端（固定）角色】关联资源-保存角色关联资源操作
exports.saveMobAppRoleRescAndAction = function (data, callback) {
    api.post('/retailer/authx/mob/role/resc/action/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 公司岗位关联/更换关联商户模板岗位
exports.updateRetailerComRoleContactTpl = function (data, callback) {
    api.post('/retailer/authx/com/role/contact/tpl/do')
    .data(data)
    .done(callback)
    .go();
};
// 保存零售商员工岗位(批量)
exports.saveRetailerStaffRoleBatch = function (data, callback) {
    api.post('/retailer/authx/staff/role/batch/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 获取公司人员角色列表根据userId
exports.getRetailerStaffRoleDtoList = function (data, callback) {
    api.get('/retailer/authx/staff/role/dto/list/get/by/userId')
    .params(data)
    .done(callback)
    .go();
};
// 根据关联商户岗位模版id查询岗位列表
exports.getRetailerComRoleBySrcTplId = function (data, callback) {
    api.get('/retailer/authx/com/role/list/list/get/by/srcTplId')
    .params(data)
    .done(callback)
    .go();
};
// 查询机构岗位的列表
exports.getRetailerComRolePageList = function (data, callback) {
    api.post('/retailer/authx/com/role/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 修改岗位-门店标签
exports.updateRetailerComRoleSubShopFilterTags = function (data, callback) {
    api.post('/retailer/authx/com/role/SubShopFilterTags/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 获取商户岗位_设备分类分组列表
exports.getRetailerComRoleDevcGroupList = function (data, callback) {
    api.get('/retailer/authx/role/devcGroup/list/get')
    .params(data)
    .done(callback)
    .go();
};
// 保存商户岗位_设备分类分组
exports.saveRetailerComRoleDevcGroup = function (data, callback) {
    api.post('/retailer/authx/role/devcGroup/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getDevcGroupListByContext = function (data, callback) {// 查询设备分类分组(权限过滤) -- 用于权限过滤
    api.post('/retailer/authx/devc/group/list/get/by/context')
    .data(data)
    .done(callback)
    .go();
};
exports.getDevcGroupCascListByContext = function (data, callback) {// 查询设备分类分组(权限过滤) -- 用于权限过滤
    api.post('/retailer/authx/devc/group/casc/list/get/by/context')
    .sync(true)
    .data(data)
    .done(callback)
    .go();
};
exports.getRetailerComRoleMgmtArea = function (data, callback) {// 查询设备分类分组(权限过滤) -- 用于权限过滤
    api.post('/retailer/authx/com/role/mgmt/area/get/by/uk')
    .data(data)
    .done(callback)
    .go();
};
exports.getRetailerComRoleMgmtAreaAreaIds = function (data, callback) {// 查询设备分类分组(权限过滤) -- 用于权限过滤
    api.post('/retailer/authx/com/role/mgmt/area/areaIds/get')
    .data(data)
    .done(callback)
    .go();
};
exports.saveRetailerComRoleMgmtAreas = function (data, callback) {// 查询设备分类分组(权限过滤) -- 用于权限过滤
    api.post('/retailer/authx/com/role/mgmt/areas/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 获取岗位布放区
exports.getRetailerPostLayoutAreaListByFilter = function (data, callback) {
    api.post('/retailer/authx/post/layout/area/list/get/by/filter')
    .data(data)
    .done(callback)
    .go();
};
// 保存岗位布放区
exports.saveRetailerPostLayoutArea = function (data, callback) {
    api.post('/retailer/authx/post/layout/area/save/do')
    .data(data)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/retailerAuthx.js
// module id = 37
// module chunks = 0